window.jQuery = window.$ = require("jquery");
var processInclude = require("base/util");

$(document).ready(function () {
    processInclude(require("./components/customSearch"));
});

require("slick-carousel/slick/slick.min.js");
require("jquery-mask-plugin/src/jquery.mask.js");
require("base/thirdParty/bootstrap");
require("base/components/spinner");
require("bootstrap/js/src/popover.js");
